const typeToStyle = {
  string: "string",
  money: "currency",
  integer: "decimal",
  float: "decimal",
  percentage: "percent"
};
const findKeyInColumns = (key, columns) => columns.findIndex((col) => col.key === key);
const mapRowToColumns = (rawData) => {
  if (!rawData || !rawData.columns || !rawData.data || rawData.data.length === 0) {
    return {};
  }
  const {
    columns,
    data
  } = rawData;
  return columns.reduce((acc, col, idx) => {
    const {
      key,
      ...other
    } = col;
    acc[key] = {
      ...other,
      value: data[0]?.[idx] ?? null
    };
    return acc;
  }, {});
};
const mapAllDataToColumns = (rawData) => {
  const {
    columns,
    data
  } = rawData;
  return data.map((row) => columns.reduce((acc, col, idx) => {
    const {
      key,
      ...other
    } = col;
    acc[key] = {
      ...other,
      value: row[idx] ?? null
    };
    return acc;
  }, {}));
};
export {
  findKeyInColumns,
  mapAllDataToColumns,
  mapRowToColumns,
  typeToStyle
};
